import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div>
            <h3>4040 - Not found</h3>
        </div>
    );
};

export default NotFound;